const draftLoadIdPrefix = 'draft-'

export function createDraftLoadId(index: number): string {
  return `${draftLoadIdPrefix}${index}`
}

export function isDraftLoadId(loadId: string): boolean {
  return loadId.startsWith(draftLoadIdPrefix)
}
